import React, { useEffect, useRef, useState } from "react";

import { motion, animate } from "motion/react";
import { DoorAnimation } from "./compat";
import EmojiWave from "./emojiWave";
import { useMusicPlayer } from "../music/musicPlayerContext";

export const CompatAvatarAnimation = ({ user, me, score }) => {
  const [step, setStep] = useState(0);
  const [avatarSmall, setAvatarsSmall] = useState(false);
  const { playMusic } = useMusicPlayer();

  const nextStep = () => {
    if (step == 2) {
      setStep(0);
    } else {
      setStep(step + 1);
    }
  };

  useEffect(() => {
    playMusic();
  });

  useEffect(() => {
    //Implementing the setInterval method
    const interval = setInterval(() => {
      var newStep = step + 1;
      if (newStep == 1) {
        setAvatarsSmall(true);
      }

      nextStep();
    }, 2000);

    //Clearing the interval
    return () => clearInterval(interval);
  }, []);

  const renderState = (state) => {
    switch (state) {
      case 1:
        return <DoorAnimation top={score} />;
      default:
        return <div></div>;
    }
  };

  return (
    <div className="compat-avatar-animation">
      {step == 0 && (
        <span className="compat-text-headline">
          {" "}
          most compatible
          <br /> friend
        </span>
      )}

      <motion.div
        className="compat-content"
        initial={{
          backgroundSize: "70%",
        }}
        animate={
          avatarSmall
            ? { backgroundSize: "0%" } // Second animation state
            : { backgroundSize: "80%" } // First animation state
        }
      >
        <div className="compat-door-container">{renderState(step)}</div>

        <div className="compat-avatars">
          <motion.div
            className="compat-avatar-container compat-avatar-container-left"
            initial={{ x: "-50%", y: "3%", rotate: 0, scale: 1 }}
            animate={
              avatarSmall
                ? { x: "10%", y: "-60%", rotate: -9, scale: 0.4 } // Second animation state
                : { x: "5%", y: "0%", rotate: -9, scale: 1 } // First animation state
            }
            transition={{
              duration: 0.8,
              delay: 0.0,
              ease: [0, 0.71, 0.2, 1.01],
            }}
          >
            {me && (
              <img
                className="compat-avatar compat-avatar-left"
                src={me.image}
              />
            )}
          </motion.div>

          <motion.div
            className="compat-avatar-container compat-avatar-container-right"
            initial={{ x: "150%", rotate: 0, scale: 1 }}
            animate={
              avatarSmall
                ? { x: "75%", y: "50%", rotate: 20, scale: 0.5 } // Second animation state
                : { x: "75%", y: "10%", rotate: 20, scale: 1 } // First animation state
            }
            transition={{
              duration: 0.8,
              delay: 0.0,
              ease: [0, 0.71, 0.2, 1.01],
            }}
          >
            {user && (
              <img
                className="compat-avatar compat-avatar-right"
                src={user.image}
              />
            )}
          </motion.div>
        </div>
      </motion.div>

      {user && user.name && (
        <h1 className="compat-title headline">
          {user.name} {step == 1 && "& you"}
        </h1>
      )}
    </div>
  );
};
